import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import { Button } from '../../shared/components/Button';
import DataTable from '../../shared/components/DataTable';
import DotsHorizontalIcon from '../../shared/components/Icon/DotsHorizontalIcon';
import { Popover, PopoverContent, PopoverTrigger, } from '../../shared/components/Popover';
import { route } from '../../shared/utils';
import SMSListHeader from './components/SMSListHeader';
import useGetSMSTemplateList from './hooks/useGetSMSTemplateList';
const SMSListPage = () => {
    const { data } = useGetSMSTemplateList();
    const fields = [
        {
            heading: 'Name',
            key: 'name',
        },
        {
            heading: 'Type',
            key: 'type',
        },
        {
            heading: 'Description',
            key: 'description',
            itemClassName: 'min-w-[300px]',
            itemShouldRender: (item) => {
                return _jsx("p", { className: "text-wrap word-break", children: item.description });
            },
        },
        {
            heading: 'Content',
            key: 'content',
            itemClassName: 'min-w-[300px]',
            itemShouldRender: (item) => {
                return _jsx("p", { className: "text-wrap word-break", children: item.content });
            },
        },
        {
            heading: 'Is TCPA',
            key: 'is_tcpa',
            itemShouldRender: (item) => {
                return item.is_tcpa ? 'Yes' : 'No';
            },
        },
        {
            heading: 'Status',
            key: 'occurred_events',
            itemShouldRender: (item) => {
                return item.status === 'A' ? 'Active' : 'Inactive';
            },
        },
        {
            heading: 'Date created',
            key: 'created_at',
            itemShouldRender: (item) => {
                return item.created_at ? format(item.created_at, 'MM/dd/yyyy') : '';
            },
        },
        {
            heading: 'Action',
            key: 'action',
            itemShouldRender: (item) => {
                return (_jsxs(Popover, { children: [_jsx(PopoverTrigger, { asChild: true, children: _jsx(Button, { variant: "outline", className: "border-none", children: _jsx(DotsHorizontalIcon, {}) }) }), _jsx(PopoverContent, { className: "w-[162px] p-[0px]", children: _jsx("div", { className: "text-default text-sm", children: _jsx(Link, { to: route(`/templates/sms/${item.id}`), children: _jsx("div", { className: "py-3 px-4 hover:bg-[#E5E7EB]", children: "Edit template" }) }) }) })] }));
            },
        },
    ];
    return (_jsxs(_Fragment, { children: [_jsx(SMSListHeader, {}), _jsx(DataTable, { fields: fields, data: data })] }));
};
export default SMSListPage;
